import JsonView from 'react18-json-view'

export const JsonViewComponent = ({
  data,
}: {
  data: Record<string, unknown>
}) => {
  return <JsonView theme="github" src={data} collapsed={1} />
}
